import {required} from "vuelidate/lib/validators";  
const documents = {
    data() { 
      return {   
        documentsData: { 
          title: "", 
          description: "", 
          topid:null,
          dataorder: 0,
          typeid: "", 
          filepath: [],        
          approval:true,
          Websiteid: "", 
          deleted: false, 
          }, 
  
          FormDataType:{
            Title:{FieldName:"title",Field:"input",FieldTitle:this.$t('documents.AddEdit.Title')},  
            Description:{FieldName:"description",Field:"input",FieldTitle:this.$t('documents.AddEdit.Description')},  
            Topid:{FieldName:"topid",Field:"input",FieldTitle:this.$t('documents.AddEdit.Topid'),ComboDataArray:[]},
            Dataorder:{FieldName:"dataorder",Field:"input",FieldTitle:this.$t('documents.AddEdit.Dataorder')},  
            Typeid:{FieldName:"typeid",Field:"Typeid",FieldTitle:this.$t('documents.AddEdit.Typeid'),ComboDataArray:[]},
            Filepath:{FieldName:"filepath",Field:"input",FieldTitle:this.$t('documents.AddEdit.Filepath')},       
            Approval:{FieldName:"approval",Field:"checkbox",FieldTitle: this.$t('documents.AddEdit.Approval')},         
            Websiteid:{FieldName:"Websiteid",Field:"input"},         
          } ,
          kayit_tipleri: [
            { Id:"1",  Value:"Klasör" },
            { Id:"2",  Value:"Dosya" },
           
          ]
      }
    },  
    validations:{ 
      FormData: {  
        title: {required},   
        description: {required},  
        topid:{},
        typeid:{required},   
        dataorder:{required},  
        filepath: {},  
        approval:{},
        Websiteid: {required},   
      }
 
  },
  created(){

    let Page= {
      PageNumber: "1",
      PageSize: "9999"
    }

    this.FormDataType.Typeid.ComboDataArray=[];
    for (var i = 0; i < this.kayit_tipleri.length; i++) {
      this.FormDataType.Typeid.ComboDataArray.push({
        Id: this.kayit_tipleri[i].Id,
        Value: this.kayit_tipleri[i].Value,
      });
    }         


    let Filter = "&Typeid=1";

    this.ActionsFilterGet({ Service: "Documents", Page: Page, Filter: Filter }).then((res) => {
      let klasorler = JSON.parse(res.Data);

            for (var i = 0; i <klasorler.length; i++) {
              this.FormDataType.Topid.ComboDataArray.push({
                Id: klasorler[i].id,
                Value: klasorler[i].title,
              });
            }
        
          });
           

  }
}
export default documents